// extracted by mini-css-extract-plugin
export default {"page":"NotFoundPage_page__262QA","code":"NotFoundPage_code__OliyG","title":"NotFoundPage_title__q392v","text":"NotFoundPage_text__d1pUB"};